<template>
  <div>
    <div class="advImageManage div-layout">
      <module-title title="广告图管理">
        <div class="right">
          <el-button type="primary" size="medium" icon="el-icon-plus" @click="dialogVisible = true">
            添加广告图
          </el-button>
        </div>
      </module-title>
      <el-table v-loading="listLoading" :data="viewData" highlight-current-row fit element-loading-text="Loading" class="list-table">
        <el-table-column type="index" width="55" align="center" label="序号" />
        <el-table-column label="终端" align="center" prop="terminalTypeName" />
        <el-table-column label="位置" align="center" width="150" prop="locationIdName" />
        <el-table-column label="图片" align="center" width="150" prop="photoPath">
          <template slot-scope="scope">
            <el-image style="width: 80px; height: 40px" :src="scope.row.photoPathAbsoluteUrl" :preview-src-list="[scope.row.photoPathAbsoluteUrl]" />
          </template>
        </el-table-column>
        <el-table-column label="顺序" align="center" prop="url">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.seq"
              maxlength="9"
              style="width:80px;"
              oninput="value=value.replace(/[^\d]/g,'')"
              @blur="rankHandle(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" prop="createDate" />
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            {{ scope.row.status == 0 ? '不显示':'显示' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="260">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="handleEdit(scope.row)">
              编辑
            </el-button>
            <el-button v-show="scope.row.status==1" size="small" @click="cancleDisplay(scope.row)">
              取消显示
            </el-button>
            <el-button v-show="scope.row.status==0" size="small" style="width:80px" @click="handleReveal(scope.row)">
              显示
            </el-button>
            <el-button type="danger" size="small" @click="handlerDelete(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :total="pageObj.total" :page.sync="pageObj.pageNum" :limit.sync="pageObj.pageSize" @pagination="pageCurriculumList" @handleSizeChange="handleSizeChange" />
      <el-dialog width="600px" :close-on-click-modal="false" :visible.sync="dialogVisible" :title="handleType=='add'?'添加广告图':'编辑广告图'" @close="dialogClose">
        <el-form ref="handleForm" :rules="rules" size="small" label-width="80px" :model="handleForm">
          <el-form-item label="终端" prop="terminalType">
            <el-select v-model="handleForm.terminalType" placeholder="请选择">
              <el-option v-for="(v,i) in terminaltypeArr" :key="i" :label="v.name" :value="v.code" />
            </el-select>
          </el-form-item>
          <el-form-item label="位置" prop="locationId">
            <el-select v-model="handleForm.locationId" placeholder="请选择">
              <el-option v-for="(v,i) in advtypeArr" :key="i" :label="v.name" :value="v.code" />
            </el-select>
          </el-form-item>
          <el-form-item label="图片" prop="photoPath">
            <!-- <el-button type="primary" icon="el-icon-upload2" @click="dialogImgVisible= true">上传图片</el-button> -->
            <upload-file
              :props="{serveCode:'train_website_advertising_pic',accept:'.png, .jpg, .jpeg',type:['image/jpeg','image/jpg','image/png']}"
              @uploadSucess="uploadSucessFn"
            >
              <el-button size="small" type="primary">
                上传图片
              </el-button>
            </upload-file>
          </el-form-item>
          <div v-show="imgUrl" class="imgBox">
            <el-image style="width: 200px; height: 50px" :src="imgUrl" :preview-src-list="[imgUrl]" />
          </div>
          <el-form-item label="链接地址">
            <el-input v-model="handleForm.linkPath" />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="dialogClose">
            取消
          </el-button>
          <el-button type="primary" size="medium" :loading="ajaxLoading" @click="handleSubmitForm">
            {{ ajaxLoading ? "Loading" : "保存" }}
          </el-button>
        </div>
      </el-dialog>
      <el-dialog v-if="dialogImgVisible" :close-on-click-modal="false" :visible.sync="dialogImgVisible" title="广告图上传" append-to-body :width="`${vueCropperImgProps.width>100?vueCropperImgProps.width+200:400}px`">
        <vue-cropper-img :props-w-h="vueCropperImgProps" serve-code="train_website_advertising_pic" :size="5" @closeDialog="closeDialogFn" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getDictsType } from '@/api/productOperation/public/FQColumnmanages';
import { getAdvertisingPageList, addAdvertising, deleteAdvertising, changeAdvertisingDisable, changeAdvertisingEnable, changeAdvertisingSeq, getAdvertisingDetail, editAdvertising } from '@/api/officialWebsiteConfig/index';
export default {
  data() {
    return {
      listLoading: false,
      viewData: [],
      dialogVisible: false,
      rules: {
        terminalType: [
          { required: true, message: '请选择终端类型', trigger: 'change' }
        ],
        locationId: [
          { required: true, message: '请选择广告位置', trigger: 'change' }
        ],
        photoPath: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ]
      },
      value: '',
      ajaxLoading: false,
      dialogImgVisible: false,
      vueCropperImgProps: {
        width: 600,
        heigth: 80,
        enlarge: 2
      },
      pageObj: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      handleForm: {
        linkPath: '', // 链接地址
        locationId: '', // 广告位置：1.首页；2.课程案例；3.关于我们；
        photoPath: '', // 广告图片地址（相对）
        terminalType: ''// 终端类型：1.PC端；2.手机端；
      },
      imgUrl: '',
      advDetail: {},
      handleType: 'add',
      terminaltype1: 'train_website_terminal_type', // 广告终端字典
      terminaltype2: 'train_website_adv_location', // 广告位置字典
      terminaltypeArr: [],
      advtypeArr: []
    };
  },
  mounted() {
    this.getType();
    this.getTableList();
  },
  methods: {
    // 获取类型列表
    getType() {
      getDictsType(this.terminaltype1).then(res => {
        this.terminaltypeArr = res.data;
      });
      getDictsType(this.terminaltype2).then(res => {
        this.advtypeArr = res.data;
      });
    },
    handleSubmitForm() {
      this.$refs['handleForm'].validate((valid) => {
        if (valid) {
          this.ajaxLoading = true;
          if (this.handleForm.id) {
            editAdvertising(this.handleForm).then((res) => {
              this.ajaxLoading = false;
              this.$notify.success({ title: 'Success', message: '修改成功', showClose: false, duration: 2000 });
              this.getTableList();
              this.dialogClose();
            }).catch(() => {
              this.ajaxLoading = false;
            });
          } else {
            addAdvertising(this.handleForm).then((res) => {
              this.ajaxLoading = false;
              this.$notify.success({ title: 'Success', message: '操作成功', showClose: false, duration: 2000 });
              this.getTableList();
              this.dialogClose();
            }).catch(() => {
              this.ajaxLoading = false;
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    uploadSucessFn(val) {
      this.handleForm.photoPath = val.relativePath;
      this.imgUrl = val.absolutePath;
    },
    handleEdit(row) {
      getAdvertisingDetail(row.id).then(res => {
        const { id, locationId, photoPath, terminalType, linkPath, photoPathAbsoluteUrl } = res.data;
        this.handleForm = {
          id: id,
          linkPath: linkPath,
          locationId: locationId,
          photoPath: photoPath,
          terminalType: terminalType
        };
        this.imgUrl = photoPathAbsoluteUrl;
        this.handleType = 'edit';
        this.dialogVisible = true;
      });
    },
    handlerDelete(row) {
      this.$confirm(`确定要删除该终端类型么?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        return deleteAdvertising(row.id);
      }).then(res => {
        this.$notify.success({ title: 'Success', message: '删除成功', showClose: false, duration: 2000 });
        this.getTableList();
      }).catch(() => {});
    },
    // 取消显示
    cancleDisplay(row) {
      this.$confirm(`确定取消显示该终端类型么?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        return changeAdvertisingDisable(row.id);
      }).then(res => {
        this.$notify.success({ title: 'Success', message: '取消成功', showClose: false, duration: 2000 });
        this.getTableList();
      }).catch(() => {});
    },
    // 显示
    handleReveal(row) {
      this.$confirm(`确定显示该终端类型么?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        return changeAdvertisingEnable(row.id);
      }).then(res => {
        this.$notify.success({ title: 'Success', message: '启用成功', showClose: false, duration: 2000 });
        this.getTableList();
      }).catch(() => {});
    },
    rankHandle(row) {
      changeAdvertisingSeq(row.id, row.seq).then((res) => {
        this.getTableList();
      });
    },
    dialogClose() {
      this.handleForm = this.$options.data().handleForm;
      this.dialogVisible = false;
      this.handleType = 'add';
      this.imgUrl = '';
      this.$refs.handleForm.resetFields();
    },
    closeDialogFn(val) {
      this.dialogImgVisible = false;
      this.handleForm.photoPath = val.relativePath;
      // this.$set(this.handleForm, 'photoPath', val.relativePath);
      this.imgUrl = val.absolutePath;
      this.$refs.handleForm.validateField('photoPath');
      this.$forceUpdate();
    },
    // 分页
    pageCurriculumList(obj) {
      this.pageObj.pageNum = obj.page;
      this.getTableList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.pageObj.pageNum = 1;
      this.pageObj.pageSize = obj.limit;
      this.getTableList();
    },
    // 获取列表
    getTableList() {
      this.listLoading = true;
      getAdvertisingPageList({ pageNum: this.pageObj.pageNum, pageSize: this.pageObj.pageSize }).then(res => {
        this.listLoading = false;
        if (res.data === null || res.data === '' || res.data === 'undefind') {
          this.viewData = [];
          this.pageObj.total = 0;
        } else {
          this.viewData = res.data.list;
          this.pageObj.total = res.data.total;
        }
      }).catch(err => {
        this.listLoading = false;
        console.log(err);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.up-box{
  // /deep/.el-form-item__label:before {
  //   content: '*';
  //   color: #F56C6C;
  //   margin-right: 4px;
  // }
}
.imgBox{
  margin-left: 80px;
  margin-bottom: 10px;
}
</style>
